/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { useNavigate } from '@reach/router';
import _ from 'lodash';
import { Empty } from 'antd';
import timeAgo from 'node-time-ago';
import moment from 'moment';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

const MARK_AS_SEEN = gql`
    mutation markAsSeenNotification($notif_uid: String) {
		markAsSeenNotification(notif_uid: $notif_uid)
    }
`;

const Index = ({
	notifications,
	unreadNotifications,
	subscribeToNewNotifications
}) => {

	useEffect(() => {
		subscribeToNewNotifications();
	}, []);

	const navigate = useNavigate();

	const [ markAsSeenNotification ] = useMutation(MARK_AS_SEEN);
				
	return (
		<li className='nav-item dropdown dropdown-list'>
			<a class="nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" data-toggle="dropdown"><em class="icon-bell"></em>
				<i className="fe-bell noti-icon"></i>
				{
					(unreadNotifications.length > 0) &&
					<span className="badge badge-danger">
						{unreadNotifications.length}
					</span>
				}
			</a>
			<div class="dropdown-menu dropdown-menu-right animated flipInX">
				<div class="dropdown-item">
					<div class="list-group">
						{
							(notifications.length == 0) && <Empty/>
						}
						{
							(notifications.length > 0) && notifications.map((notification, key) => {
								const notSeen = (notification.is_seen == 0) ? 'active' : null;
								return (
									<div 
										key={key}
										class={`list-group-item list-group-item-action notify-item ${notSeen}`} 
										style={{ cursor: 'pointer' }}
										onClick={() => {
											if (notSeen) {
												markAsSeenNotification({ 
													variables: { notif_uid: notification.uid },
													refetchQueries: ['userNotifications']
												});
											}
											if (notification.link_url) {
												navigate(notification.link_url, { replace: true });
											}
									}}>
										<div class="media">
										<div class="align-self-start mr-2">
											{/* <em class="fab fa-twitter fa-2x text-info"></em> */}
											{
												notification.icon_url &&
												<img width='45' height='auto' src={`${process.env.REACT_APP_BACKEND}${notification.icon_url}`} alt='icon-logo' />
											}
										</div>
										<div class="media-body">
											<p class="m-1">{notification.notification_message}</p>
											<p class="m-1 text-muted text-sm">{timeAgo(moment(notification.created_at).format('YYYY-MM-DD HH:mm:ss'))}</p>
										</div>
										</div>
									</div>
								);
							})
						}
						<div class="list-group-item list-group-item-action" style={{ cursor: 'pointer' }} onClick={() => {

						}}><span class="d-flex align-items-center"><span class="text-sm">See all notifications</span></span></div>
					</div>
				</div>
			</div>
		</li>
	);
};

export default Index;